window.Hammer = require("hammerjs");
window.DSLocalForageAdapter = require("js-data-localforage");
require("js-data-angular");
require("angular-animate");
require("angular-touch");
require("angular-sanitize");
require("angular-ui-router");
require("angular-toastr");
require("angular-toastr-css");
require("oclazyload");
require("angular-hammer");
require("angular-ui-bootstrap");
require("jscolor");

require("localforage").config({
  // driver      : localforage.WEBSQL, // Force WebSQL; same as using setDriver()
  name: "oneconnect",
  version: 1.0,
  size: 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName: API_URL.replace(/https?:\/\//, "")
    .replace(/[^a-zA-Z0-9_]/, "_")
    .replace(/_$/, ""), // Should be alphanumeric, with underscores.
  description: "app data"
});
window.MobileDetect = require("mobile-detect");
window.Swiper = require("swiper");
require("swiper-css");

import(/* webpackChunkName: "moment" */
/* webpackMode: "lazy" */
"moment").then(function(moment) {
  window.moment = moment;

  window.lang = navigator.languages
    ? navigator.languages[0]
    : navigator.language || navigator.userLanguage;
  const baseLang = window.lang.split("-")[0];

  if (baseLang === "fr") {
    import(/* webpackChunkName: "moment/locale/fr" */
    /* webpackMode: "lazy" */
    "moment/locale/fr").then(localeData => {
      moment.locale(baseLang, localeData);
    });
  }
});

if (window.bootstrap) {
  window.bootstrap();
} else {
  window.bootstrapNow = true;
}



// WEBPACK FOOTER //
// ./src/vendor.js